import React, { useEffect, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import useStyles from './style';
import { Box } from '@material-ui/core';
import Button from '../../../components/atoms/Button';
import Typography from '../../../components/atoms/Typography';
import AdCalenderCarousel from '../../../components/organism/AdCalenderCarousel/AdCalenderCarousel';
import { get } from 'lodash';
import ButtonMUI from '../../../components/atoms/Button';
import clsx from 'clsx';
import fetchService from '../../../../services/FetchService';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { getStartAndEndDate, transformLink } from '../../../../utils/utility';
import { getUId } from '../../../../utils/utility';
import { eventsCountFormat, getDateRangeTabDates } from '../Filters/helpers';

const createSVG = (type = '', fill = '', customClass = '') => {
  switch (type) {
    case 'cross':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 12" fill="none">
          <path d="M2 2L10 10M2 10L10 2" stroke="white" stroke-width="2" stroke-linecap="round" />
        </svg>
      )
    default:
      return <></>
  }
};

const EventsTabsFilter = (props) => {
  const filterObject = (key, value) => {
    return (
      { key, value }
    )
  }
  const { fields, appConfig, sitecoreContext } = props
  const tabs = get(props, 'fields.Tabs', '');
  const uid = getUId(props)
  const [activeTab, setActiveTab] = useState(0);
  const [daysEventCounts, setDaysEventCounts] = useState(null)
  const hasUpcomingEvents = daysEventCounts && Object.values(daysEventCounts).some(count => count > 0) || false;
  const [response, setResponse] = useState('');
  const [filterValues, setFilterValues] = useState(filterObject('dateCategories', get(tabs[0], 'fields.taxonomyKey.value', '')));

  const classes = useStyles();

  const title = get(props, 'fields.Title.value', '');
  let cta = get(props, 'fields.Cta', '');
  cta = transformLink(cta)
  const limit = get(fields, 'Limit.value', '10');
  const currentTaxonomyKeyValue = get(tabs, `${activeTab}.fields.taxonomyKey.value`, '');
  const result = get(response, 'data.data.results', []);
  const language = get(sitecoreContext, 'language', 'en');
  const pageName = getPageName(props);
  const componentName = getComponentName(props);

  const fetchEventsCount = async () => {
    const eventCount = getDateRangeTabDates()
    const payload = { "contentType": "Event", language, facetFields: [], offset: 0, filters: [], limit: Number(limit), eventCount, onlyCount: true }
    const { data: { data: { countResults } } } = await fetchService({ url: `${appConfig.SMART_LIST_API}`, method: 'POST', data: payload });

    const countsFormat = eventsCountFormat(countResults);
    const tabKeys = Object.keys(countsFormat);
    const activeIndex = tabKeys.findIndex(key => countsFormat[key] > 0) || 0;

    setActiveTab(activeIndex);
    setDaysEventCounts(countsFormat);

    const { startDate, endDate } = eventCount[activeIndex];
    return { startDate, endDate };
  }

  useEffect(() => {
    (async () => {
      const { startDate, endDate } = getStartAndEndDate(currentTaxonomyKeyValue);
      let eventCountsDate = null;
      if (!daysEventCounts) eventCountsDate = await fetchEventsCount();

      try {
        const response = await fetchService({
          url: `${appConfig.SMART_LIST_API}`,
          method: 'POST',
          data: {
            "contentType": "Event",
            "language": language,
            "facetFields": [],
            "limit": Number(limit),
            "offset": 0,
            "filters": [],
            "startDate": eventCountsDate ? eventCountsDate.startDate : startDate,
            "endDate": eventCountsDate ? eventCountsDate.endDate : endDate,
            "isPreviewMode": false,
          }
        });
        setResponse(response);
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, [filterValues]);

  const handleFilterBtnOnClick = (taxonomyKeyValue) => {
    const idx = tabs.findIndex(item => item.fields.taxonomyKey.value === taxonomyKeyValue)
    setFilterValues(filterObject('dateCategories', get(tabs[idx], 'fields.taxonomyKey.value', '')))
    setActiveTab(idx)
  }

  const FilterBtn = (props) => (
    <ButtonMUI
      component="span"
      buttonType={'whitePillContrast'}
      hideEndIcon={true}
      size={'small'}
      hasBorder={false}
      endIcon={''}
      onClick={() => handleFilterBtnOnClick(props?.taxonomyKey?.value)}
      className={clsx('filterBtn', currentTaxonomyKeyValue === props?.taxonomyKey?.value && 'active')}>
      {props.text}
      {createSVG('cross')}
    </ButtonMUI>
  );
  const filterBtns = daysEventCounts && tabs && Array.isArray(tabs) && tabs.filter(o => daysEventCounts[o.fields.taxonomyKey.value] > 0).map(item => {
    const { id, taxonomyKey, taxonomyValue } = item?.fields
    return <FilterBtn key={id} text={taxonomyValue?.value} taxonomyKey={taxonomyKey} />
  })

  return (
    <>
      {hasUpcomingEvents && (
        <Box uid={uid} className={classes.EventsTabsFilter}>
          <div className={'filterableEventsHeader'}>
            <Typography className={'eventsTitle'} variant={'h5'}>{title}</Typography>
            <Button
              className={'eventsCTA mobile'}
              component="span"
              buttonType="default"
              field={cta}
              hasBorder={false}
              animateSettings={{
                willAnimate: false,
              }}
            // onClick={() => addAnalyticsInfo(i)}
            />
            <div className={'filters-and-cta-container'}>
              <div className={'filtersWrapper'}>
                {filterBtns}
              </div>
              <div className={''}>
                <Button
                  className={'eventsCTA desktop'}
                  component="span"
                  buttonType="default"
                  field={cta}
                  hasBorder={false}
                  animateSettings={{
                    willAnimate: false,
                  }}
                // onClick={() => addAnalyticsInfo(i)}
                />
              </div>
            </div>
          </div>
          <div>
            <AdCalenderCarousel {...props} result={result} pageName={pageName} componentName={componentName} language={language} title={title} />
          </div>
        </Box>
      )}
    </>
  )
};

export default withSitecoreContext()(EventsTabsFilter);
